import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { useEffect } from 'react';
import { ListingsView } from './sections/ListingsView';
import { Package, Users } from 'lucide-react';
import { ProductsView } from './sections/ProductsView';

type ViewType = 'products' | 'listings';

export default function ExploreProducts() {
  const { t } = useTranslation('product');
  const [searchParams, setSearchParams] = useSearchParams();

  const currentView = (searchParams.get('view') as ViewType) || 'products';

  useEffect(() => {
    if (!searchParams.get('view')) {
      setSearchParams({ view: 'products' });
    }
  }, [searchParams, setSearchParams]);

  const handleViewChange = (view: ViewType) => {
    if (view === currentView) return;
    setSearchParams({ view });
  };

  const renderContent = () => {
    if (currentView === 'products') return <ProductsView />;
    return <ListingsView />;
  };

  return (
    <div className="space-y-6">
      <title>{t('product.title')}</title>
      <div>
        <h1 className="text-2xl sm:text-3xl text-neut-prim mb-2">
          {t('product.title')}
        </h1>
        <p className="text-sm text-neut-sec">{t('product.description')}</p>
      </div>
      <div className="bg-neut-0 rounded-lg border border-gray-200 p-1 shadow-sm w-[19.5rem] flex justify-center">
        <button
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            currentView === 'products'
              ? 'bg-prim text-white'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          onClick={() => handleViewChange('products')}
        >
          <div className="flex items-center gap-2">
            <Package size={16} aria-hidden="true" />
            {t('product.products_view')}
          </div>
        </button>
        <button
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            currentView === 'listings'
              ? 'bg-prim text-white'
              : 'text-gray-600 hover:text-gray-900'
          }`}
          onClick={() => handleViewChange('listings')}
        >
          <div className="flex items-center gap-2">
            <Users size={16} aria-hidden="true" />
            {t('product.listings_view')}
          </div>
        </button>
      </div>
      {renderContent()}
    </div>
  );
}
